import { render } from "./CscInspectionTankComponent.vue?vue&type=template&id=2338472a"
import script from "./CscInspectionTankComponent.vue?vue&type=script&lang=js"
export * from "./CscInspectionTankComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__